export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Mehta',
    role: 'CEO',
    company: 'MediCare Health',
    avatar: 'RM',
    rating: 5,
    quote: 'Working with this team was a game-changer for us. They built our telemedicine platform from the ground up — and the results speak for themselves. 40% increase in patient engagement and our doctors love the intuitive interface. The AI diagnosis feature alone saved us thousands of manual hours.',
    service: 'website-development',
    industry: 'Healthcare',
  },
  {
    id: 2,
    name: 'Priya Sharma',
    role: 'CTO',
    company: 'ShopNow Retail',
    avatar: 'PS',
    rating: 5,
    quote: 'We needed an e-commerce platform that could handle 10K+ products with zero slowdown. They delivered exactly that — sub-250ms page loads, 99.9% uptime, and our revenue tripled within 6 months. The AI recommendations engine they built is pure magic.',
    service: 'website-development',
    industry: 'E-Commerce',
  },
  {
    id: 3,
    name: 'Vikram Joshi',
    role: 'Founder',
    company: 'FitTrack Wellness',
    avatar: 'VJ',
    rating: 5,
    quote: 'Our fitness app hit 100K downloads in 3 months and maintained a 4.8 star rating. The Flutter app they built is buttery smooth — users can\'t tell it\'s not native. The real-time workout tracking with Apple Health sync works flawlessly.',
    service: 'mobile-app-development',
    industry: 'Health & Fitness',
  },
  {
    id: 4,
    name: 'Anita Desai',
    role: 'Operations Director',
    company: 'TransGlobal Logistics',
    avatar: 'AD',
    rating: 5,
    quote: 'The ERP system transformed our entire logistics operation. 30% cost reduction, 50% faster deliveries — numbers that directly hit our bottom line. Their team understood our complex supply chain requirements better than we expected anyone could.',
    service: 'erp-solutions',
    industry: 'Logistics',
  },
  {
    id: 5,
    name: 'Karan Malhotra',
    role: 'VP Sales',
    company: 'GrowthStack Inc.',
    avatar: 'KM',
    rating: 5,
    quote: 'SalesPulse CRM doubled our team\'s productivity. Lead conversion went up 45% and the pipeline visibility is incredible. The AI lead scoring actually works — it\'s not just a buzzword. It flags high-intent leads our reps would have missed.',
    service: 'crm-solutions',
    industry: 'B2B SaaS',
  },
  {
    id: 6,
    name: 'Sneha Reddy',
    role: 'Head of Engineering',
    company: 'NexaTech Corp',
    avatar: 'SR',
    rating: 5,
    quote: 'Zero-downtime migration of 500+ workloads to AWS. The entire process was smooth and the cost savings are real — 70% reduction in infrastructure spend. Their Kubernetes setup with auto-scaling is exactly what we needed for our unpredictable traffic.',
    service: 'cloud-solutions',
    industry: 'Technology',
  },
  {
    id: 7,
    name: 'Arun Nair',
    role: 'Marketing Director',
    company: 'BrandVista Agency',
    avatar: 'AN',
    rating: 5,
    quote: 'The AI marketing platform they built generates 10x more content than our team ever could. 200% ROI improvement is real. The A/B testing engine automatically optimizes campaigns while we sleep. Best investment our agency ever made.',
    service: 'ai-automation',
    industry: 'Marketing',
  },
  {
    id: 8,
    name: 'Deepa Krishnan',
    role: 'Principal',
    company: 'EduLearn Academy',
    avatar: 'DK',
    rating: 5,
    quote: '50,000+ students use our learning app daily and the feedback is overwhelmingly positive. 92% course completion rate is unheard of in EdTech. The gamification elements keep students engaged, and the AI tutor chatbot answers questions instantly.',
    service: 'mobile-app-development',
    industry: 'Education',
  },
  {
    id: 9,
    name: 'Manish Gupta',
    role: 'CEO',
    company: 'RestaPro Hospitality',
    avatar: 'MG',
    rating: 5,
    quote: 'Custom restaurant management software that actually understands hospitality. Table reservations, kitchen display, inventory — all in one place. 25% revenue boost came from better table turnover and reduced food waste. The team was incredibly responsive throughout.',
    service: 'custom-software',
    industry: 'Hospitality',
  },
  {
    id: 10,
    name: 'Rohit Bansal',
    role: 'CTO',
    company: 'FinSecure Technologies',
    avatar: 'RB',
    rating: 5,
    quote: 'Processing 1M+ transactions daily with 99.97% uptime is no joke. Their fintech expertise is top-notch — PCI-DSS Level 1 compliance, fraud detection that catches 99.8% of attempts, and the architecture scales beautifully. Would recommend without hesitation.',
    service: 'custom-software',
    industry: 'Fintech',
  },
  {
    id: 11,
    name: 'Lakshmi Iyer',
    role: 'Creative Director',
    company: 'DesignCraft Studio',
    avatar: 'LI',
    rating: 5,
    quote: 'The design system they built powers 20+ of our SaaS products now. 4x faster design-to-dev handoff is not an exaggeration — it transformed how our teams work together. Every component is thoughtfully designed and the documentation is impeccable.',
    service: 'ui-ux-design',
    industry: 'Design',
  },
  {
    id: 12,
    name: 'Sanjay Patel',
    role: 'Managing Director',
    company: 'PrecisionMold Engineering',
    avatar: 'SP',
    rating: 5,
    quote: 'We needed a manufacturing ERP that could handle our precision engineering workflows. Off-the-shelf solutions didn\'t cut it. Their custom ERP handles everything — from raw material tracking to quality inspection reports. Shop floor productivity is up 35%.',
    service: 'erp-solutions',
    industry: 'Manufacturing',
  },
];